import { createSelector } from 'reselect';

import type { ReduxStore } from '../store';

export const getCommentsStore = (state: ReduxStore) => state.comments;
export const getComments = createSelector([getCommentsStore], comments => comments.comments);

export const getStatus = createSelector([getCommentsStore], (comments) => comments.status);

export const getCommentsByProjectId = createSelector([
  getComments,
  (_state: ReduxStore, projectId: string) => projectId,
], (comments, projectId) => comments[projectId] || []);

export const getCommentsCount = createSelector([
  getCommentsByProjectId,
], (comments) => comments?.length ?? 0);
